import { useState, useEffect } from 'react'
import { Form, Button } from 'react-bootstrap'
import queryString from 'query-string'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import {
  Article,
  Dropdown,
  LeadingTitle,
  FooterSection,
  Pagination,
} from '@components'
import { Search, Filter, ChevronDown } from '@icons'
import { NewsAPINew, ShortDescriptionAPI } from '@api'
import { useQuery } from '@hooks'

const InvestorContainer = styled.div`
  background-color: #f9f9f9;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const Announcement = function () {
  const { t } = useTranslation()
  const [shortDesc, setShortDesc] = useState(null)
  useEffect(() => {
    const loadData = async () => {
      const { data } = await ShortDescriptionAPI({ loc: 'pengumuman' })
      setShortDesc(data.data)
    }

    if (!shortDesc) {
      loadData()
    }
  }, [shortDesc])
  return (
    <InvestorContainer>
      <LeadingTitle
        title={t('pengumuman')}
        subtitle={shortDesc !== null ? shortDesc[0].description : ''}
      />
      <Body />
      <FooterSection currentPage={t('pengumuman')} />
    </InvestorContainer>
  )
}

const Body = function () {
  const { t } = useTranslation()
  const [news, setNews] = useState({})
  const [year, setYear] = useState(null)
  const [search, setSearch] = useState('')
  const [searchQuery, setSearchQuery] = useState('')
  const [yearCollection, setYearCollection] = useState()
  const query = useQuery()
  const history = useHistory()
  const page = query.get('page') || 1

  const generateYear = () => {
    const currentYear = new Date().getFullYear()
    let collection = []
    collection.push({
      year: 0,
      selected: false,
    })

    for (let x = currentYear - 10; x <= currentYear; x++) {
      collection.push({
        year: x,
        selected: false,
      })
    }

    setYearCollection(collection)
  }

  useEffect(() => {
    generateYear()
  }, [])

  useEffect(() => {
    const loadNews = async () => {
      const filter = {
        loc: 'pengumuman',
        page,
        search: searchQuery,
        orderBy: 'desc',
      }
      if (year) {
        filter.from = `${year}-01-01`
        filter.to = `${year}-12-31`
      }
      const { data } = await NewsAPINew(queryString.stringify(filter))
      setNews(data?.data || {})
    }

    loadNews()
  }, [searchQuery, year, page])

  const handleUpdateSearch = (e) => {
    setSearch(e.target.value)
  }

  const handleSearch = () => {
    history.push({
      search: `?`,
    })
    setSearchQuery(search)
  }

  const handleYear = (year) => {
    history.push({
      search: `?`,
    })
    setYear(year)
  }

  const createPagination = () => {
    const { total, per_page } = news
    return {
      totalItems: total,
      currentPage: +page,
      limit: per_page,
    }
  }

  return (
    <div className="news-room-page">
      <div className="news-room-page-content">
        <div className="news-room-page-content-left">
          {news.result
            ? news?.result?.map((data, i) => {
                return (
                  <Article
                    key={i}
                    date={data.created_at}
                    title={data.title}
                    subtitle={data.description}
                    readMore="tr"
                    slug={data.slug}
                    largeTitle="title-large"
                    type={'announcement'}
                  />
                )
              })
            : 'pencarian tidak ditemukan'}
          {news.result && (
            <nav
              className="pagination-box d-flex align-items-center justify-content-center"
              aria-label="News Pagination"
            >
              <ul className="pagination">
                <Pagination {...createPagination()} />
              </ul>
            </nav>
          )}
        </div>
        <div className="news-room-page-content-right">
          <div className="label-box">
            <Search fill="#85714d" className="label-box-icon" />
            <div className="label-box-title">{t('pencarian')}</div>
          </div>
          <div className="input-box">
            <Form.Group controlId="search">
              <Form.Control
                type="text"
                placeholder={t('masukan_kata_kunci')}
                value={search}
                onChange={handleUpdateSearch}
              />
            </Form.Group>
          </div>
          <div className="button-box">
            <Button
              className="w-100 justify-content-center"
              variant="warning"
              onClick={handleSearch}
            >
              {t('search')}
            </Button>
          </div>
          <div className="label-box">
            <Filter fill="#85714d" className="label-box-icon" />
            <div className="label-box-title">Filter</div>
          </div>
          <div className="filter-box">
            <div className="filter-item">
              <Dropdown
                label={t('pilih_tahun')}
                title={year || t('semua')}
                className="custom-dropdown"
                icon={ChevronDown}
                items={yearCollection}
                onClick={handleYear}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Announcement
